import _find from 'lodash/find'
import _toLower from 'lodash/toLower'
import memoizeOne from 'memoize-one'

export const hasPermission = memoizeOne((permissions: any, target: string) => {
  return Boolean(_find(permissions || [], (p) => _toLower(p) === _toLower(target)))
})
